import { render } from "./ApplicationLink.vue?vue&type=template&id=5f990bfc"
import script from "./ApplicationLink.vue?vue&type=script&lang=js"
export * from "./ApplicationLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__